import { ViewportRuler } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { WindowResizeModule } from '®shared/window';

import { VirtualisationService } from './virtualisation.service';
import { VirtualiserComponent } from './virtualiser.component';

@NgModule({
  imports: [CommonModule, WindowResizeModule],
  declarations: [VirtualiserComponent],
  providers: [ViewportRuler, VirtualisationService],
  exports: [VirtualiserComponent],
})
export class VirtualisationModule {}
